var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transname}},[_c('keep-alive',[_c('router-view',{staticClass:"cube-view"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }